module.exports = __webpack_public_path__ + "static/media/destination-facebook.606fe319.png";